// import img_china from '../img/event2_china.jpg';
// import img_usa from '../img/event2_usa.jpg';
// import img_canada from '../img/event3_canada.jpg';
//
// [![](${img_china})](http://www.nbcolympics.com/video/chinas-chen-aisen-lin-yue-deliver-events-top-dive)
// [![](${img_usa})](http://www.nbcolympics.com/video/david-boudia-steele-johnson-clinch-silver-final-dive)
// [![](${img_canada})](http://www.nbcolympics.com/video/womens-10m-synch-bronze-comes-down-final-three-dives)

export default `
`.trim();



/** WEBPACK FOOTER **
 ** ./src/notes/event2.md.js
 **/